import { isTableCell } from '.'
import { Node as ProseMirrorNode } from 'prosemirror-model'
import { BorderSelection } from './BorderSelection'
import { TableMap } from './TableMap'
import { splitFragments } from './splitFragments'

interface BorderInfo {
  nodePos: number
  node: ProseMirrorNode
  direction: 'borderLeft' | 'borderRight' | 'borderTop' | 'borderBottom'
}

export function borderSelectionsToNodes(
  tableNode: ProseMirrorNode,
  selection: BorderSelection,
  doc: ProseMirrorNode,
): Array<BorderInfo> {
  const borderInfo: Array<BorderInfo> = []
  const tableMap = new TableMap({ posBeforeTable: selection.anchor, node: tableNode })
  selection.verticals.forEach(({ rowOrColIdx, fragmentIdx }) => {
    const rightCol = rowOrColIdx - 1
    const leftCol = rowOrColIdx
    if (typeof fragmentIdx === 'number') {
      if (rightCol >= 0) {
        const pos = tableMap.getPosAtCoord(rightCol, fragmentIdx)
        if (pos == null) return
        const cellNode = doc.nodeAt(pos)
        if (cellNode && isTableCell(cellNode)) {
          borderInfo.push({ nodePos: pos, direction: 'borderRight', node: cellNode })
        }
      }
      if (leftCol < tableMap.numCols) {
        const pos = tableMap.getPosAtCoord(leftCol, fragmentIdx)
        if (pos == null) return
        const cellNode = doc.nodeAt(pos)
        if (cellNode && isTableCell(cellNode)) {
          borderInfo.push({ nodePos: pos, direction: 'borderLeft', node: cellNode })
        }
      }
    } else {
      const fragmentList = splitFragments(tableMap.getColFragments()[rowOrColIdx])
      if (rightCol >= 0) {
        const cellPosList = fragmentList.map((idx) => tableMap.getPosAtCoord(rightCol, idx))
        cellPosList.forEach((pos) => {
          if (pos == null) return
          const cellNode = doc.nodeAt(pos)
          if (cellNode && isTableCell(cellNode)) {
            borderInfo.push({ nodePos: pos, direction: 'borderRight', node: cellNode })
          }
        })
      }
      if (leftCol < tableMap.numCols) {
        const cellPosList = fragmentList.map((idx) => tableMap.getPosAtCoord(leftCol, idx))
        cellPosList.forEach((pos) => {
          if (pos == null) return
          const cellNode = doc.nodeAt(pos)
          if (cellNode && isTableCell(cellNode)) {
            borderInfo.push({ nodePos: pos, direction: 'borderLeft', node: cellNode })
          }
        })
      }
    }
  })
  selection.horizontals.forEach(({ rowOrColIdx, fragmentIdx }) => {
    const topRow = rowOrColIdx
    const bottomRow = rowOrColIdx - 1
    if (typeof fragmentIdx === 'number') {
      if (bottomRow >= 0) {
        const pos = tableMap.getPosAtCoord(fragmentIdx, bottomRow)
        if (pos == null) return
        const cellNode = doc.nodeAt(pos)
        if (cellNode && isTableCell(cellNode)) {
          borderInfo.push({ nodePos: pos, direction: 'borderBottom', node: cellNode })
        }
      }
      if (topRow < tableMap.numRows) {
        const pos = tableMap.getPosAtCoord(fragmentIdx, topRow)
        if (pos == null) return
        const cellNode = doc.nodeAt(pos)
        if (cellNode && isTableCell(cellNode)) {
          borderInfo.push({ nodePos: pos, direction: 'borderTop', node: cellNode })
        }
      }
    } else {
      const fragmentList = splitFragments(tableMap.getRowFragments()[rowOrColIdx])
      if (bottomRow >= 0) {
        const cellPosList = fragmentList.map((idx) => tableMap.getPosAtCoord(idx, bottomRow))
        cellPosList.forEach((pos) => {
          if (pos == null) return
          const cellNode = doc.nodeAt(pos)
          if (cellNode && isTableCell(cellNode)) {
            borderInfo.push({ nodePos: pos, direction: 'borderBottom', node: cellNode })
          }
        })
      }
      if (topRow < tableMap.numRows) {
        const cellPosList = fragmentList.map((idx) => tableMap.getPosAtCoord(idx, topRow))
        cellPosList.forEach((pos) => {
          if (pos == null) return
          const cellNode = doc.nodeAt(pos)
          if (cellNode && isTableCell(cellNode)) {
            borderInfo.push({ nodePos: pos, direction: 'borderTop', node: cellNode })
          }
        })
      }
    }
  })
  return borderInfo
}
